import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidateSearchRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  officialRecordId?: string;

  @observable
  countryId?: string;

  @observable
  licensePlate?: string;

  @observable
  variableSymbol?: number;
}
